// Quick View Packing List 注入 - v5
function findVariantPicker(drawer) {
  return drawer.querySelector([
    'variant-picker',
    '.variant-picker',
    'fieldset',
    '.product-form__input',
    'form[action*="/cart/add"]'
  ].join(', '));
}

function injectPackingList(drawer) {
  if (drawer.dataset.packingInjected) return;

  const variantPicker = findVariantPicker(drawer);
  if (!variantPicker) return;

  const qv = drawer.closest('quick-view') || drawer.parentElement?.closest('quick-view');
  const productUrl = qv?.dataset?.productUrl;
  if (!productUrl) return;

  drawer.dataset.packingInjected = 'true';

  fetch(productUrl)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const packingList = doc.querySelector('.ab-packing-list');
      if (!packingList) return;

      // 提取并注入样式
      if (!document.querySelector('style[data-packing-list-style]')) {
        doc.querySelectorAll('style').forEach(function(style) {
          if (style.textContent.includes('ab-packing-list')) {
            const clonedStyle = document.createElement('style');
            clonedStyle.setAttribute('data-packing-list-style', 'true');
            clonedStyle.textContent = style.textContent;
            document.head.appendChild(clonedStyle);
          }
        });
      }

      const clone = packingList.cloneNode(true);
      clone.classList.add('ab-packing-list-qv');
      clone.style.cssText = 'margin: 0 0 16px 0 !important; padding: 12px !important; width: 100% !important;';

      const picker = findVariantPicker(drawer);
      if (picker) {
        picker.insertAdjacentElement('beforebegin', clone);
      }
    })
    .catch(function(e) { console.log('[PL] fetch error:', e); });
}

function resetDrawer(drawer) {
  delete drawer.dataset.observed;
  delete drawer.dataset.packingInjected;
  const existing = drawer.querySelector('.ab-packing-list-qv');
  if (existing) existing.remove();
}

function observeDrawer(drawer) {
  if (drawer.dataset.observed) return;
  drawer.dataset.observed = 'true';

  const observer = new MutationObserver(function() {
    if (findVariantPicker(drawer)) {
      observer.disconnect();
      injectPackingList(drawer);
    }
  });

  observer.observe(drawer, { childList: true, subtree: true });

  setTimeout(function() {
    observer.disconnect();
    injectPackingList(drawer);
  }, 3000);
}

document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('[aria-label="Close"], .drawer__close, .btn-close');
  if (closeBtn) {
    const drawer = closeBtn.closest('.drawer__inner');
    if (drawer) resetDrawer(drawer);
    return;
  }

  setTimeout(function() {
    document.querySelectorAll('.drawer__inner').forEach(function(drawer) {
      observeDrawer(drawer);
    });
  }, 100);
});

document.addEventListener('on:modal:close', function() {
  document.querySelectorAll('.drawer__inner').forEach(resetDrawer);
});
